/* ============================================================
   Subscription Option Block — JavaScript
   Handles:
   1. Panel selection (subscribe vs one-time)
   2. Selling plan form input injection
   3. Block prices update on variant change
   4. Main product price block sync
   ============================================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function initSubscriptionOption(wrapper) {
    if (wrapper.dataset.soInit) return;
    wrapper.dataset.soInit = '1';

    var sectionId       = wrapper.dataset.sectionId;
    var sellingPlanId   = wrapper.dataset.sellingPlanId;
    var defaultSelected = wrapper.dataset.default;
    var allocations     = {};

    try {
      allocations = JSON.parse(wrapper.dataset.allocations.replace(/&quot;/g, '"'));
    } catch (e) {}

    var panels = wrapper.querySelectorAll('.subscription-option__panel');

    // ── Main price block sync ─────────────────────────────────
    var originalPriceHTML = null;

    function getPriceBlock() {
      return document.querySelector('[data-so-price-target="' + sectionId + '"]');
    }

    function updateMainPriceBlock(type, data) {
      var block = getPriceBlock();
      if (!block) return;
      var priceEl   = block.querySelector('.product-price--original');
      var compareEl = block.querySelector('.product-price--compare');
      if (!priceEl) return;

      if (type === 'subscription') {
        if (originalPriceHTML === null) {
          var pd = block.querySelector('.product-price');
          if (pd) originalPriceHTML = pd.innerHTML;
        }
        var hs = priceEl.querySelector('.visually-hidden');
        if (hs) {
          Array.prototype.slice.call(priceEl.childNodes).forEach(function (n) { if (n !== hs) priceEl.removeChild(n); });
          priceEl.appendChild(document.createTextNode(formatMoney(data.sub_price)));
        } else {
          priceEl.textContent = formatMoney(data.sub_price);
        }
        if (!compareEl) {
          compareEl = document.createElement('del');
          compareEl.className = 'product-price--compare so-injected-compare';
          priceEl.parentNode.insertBefore(compareEl, priceEl.nextSibling);
        }
        compareEl.innerHTML = '<span style="text-decoration:line-through;">' + formatMoney(data.price) + '</span>';
        compareEl.style.display = '';
      } else {
        if (originalPriceHTML !== null) {
          var pd2 = block.querySelector('.product-price');
          if (pd2) pd2.innerHTML = originalPriceHTML;
        } else {
          var hs2 = priceEl.querySelector('.visually-hidden');
          if (hs2) {
            Array.prototype.slice.call(priceEl.childNodes).forEach(function (n) { if (n !== hs2) priceEl.removeChild(n); });
            priceEl.appendChild(document.createTextNode(formatMoney(data.price)));
          } else {
            priceEl.textContent = formatMoney(data.price);
          }
          var inj = block.querySelector('.so-injected-compare');
          if (inj) inj.remove();
        }
      }
    }

    // ── Selling plan ──────────────────────────────────────────
    function getProductForm() { return document.getElementById('product-form-' + sectionId); }

    function setSellingPlan(planId) {
      var form = getProductForm();
      if (!form) return;
      var input = form.querySelector('input[name="selling_plan"]');
      if (planId) {
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; form.appendChild(input); }
        input.value = planId;
      } else {
        if (input) input.remove();
      }
    }

    // ── State ─────────────────────────────────────────────────
    var currentVariantId = null;

    function getCurrentData() {
      if (currentVariantId && allocations[String(currentVariantId)]) return allocations[String(currentVariantId)];
      var keys = Object.keys(allocations);
      return keys.length ? allocations[keys[0]] : null;
    }

    function getActiveType() {
      var active = wrapper.querySelector('.subscription-option__panel.is-selected');
      return active ? active.dataset.type : defaultSelected;
    }

    // ── Panel select ──────────────────────────────────────────
    function selectPanel(type) {
      panels.forEach(function (panel) {
        var sel = panel.dataset.type === type;
        panel.classList.toggle('is-selected', sel);
        panel.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
      setSellingPlan(type === 'subscription' ? sellingPlanId : null);

      var data = getCurrentData();
      if (data) updateMainPriceBlock(type, data);
    }

    // ── Variant change ────────────────────────────────────────
    function updateBlockPrices(variantId) {
      var data = allocations[String(variantId)];
      if (!data) return;
      currentVariantId = variantId;

      var sp = wrapper.querySelector('[data-subscription-price]');
      var op = wrapper.querySelector('.subscription-option__price-original');
      var ot = wrapper.querySelector('.subscription-option__price-onetime');
      if (sp) { sp.dataset.subscriptionPrice = data.sub_price; sp.textContent = formatMoney(data.sub_price); }
      if (op) { op.dataset.originalPrice = data.price; op.textContent = formatMoney(data.price); }
      if (ot) { ot.dataset.originalPrice = data.price; ot.textContent = formatMoney(data.price); }

      originalPriceHTML = null;
      updateMainPriceBlock(getActiveType(), data);
    }

    // ── Listeners ─────────────────────────────────────────────
    panels.forEach(function (panel) {
      if (panel.classList.contains('is-unavailable')) return;

      panel.addEventListener('click', function () { selectPanel(panel.dataset.type); });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPanel(panel.dataset.type); }
      });
    });

    ['on:variant:change', 'variant:changed', 'variantChange'].forEach(function (evtName) {
      document.addEventListener(evtName, function (e) {
        var v = (e.detail && (e.detail.variant || e.detail.currentVariant)) || e.detail;
        if (v && v.id) updateBlockPrices(v.id);
      });
    });

    selectPanel(defaultSelected);
  }

  function initAll() {
    document.querySelectorAll('.subscription-option').forEach(initSubscriptionOption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
